import { render } from "./FilterKitchen.vue?vue&type=template&id=0a110941&scoped=true"
import script from "./FilterKitchen.vue?vue&type=script&lang=js"
export * from "./FilterKitchen.vue?vue&type=script&lang=js"

import "./FilterKitchen.vue?vue&type=style&index=0&id=0a110941&lang=scss"
import "./FilterKitchen.vue?vue&type=style&index=1&id=0a110941&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a110941"]])

export default __exports__